import React from 'react';
import { Button, Modal, Icon, Row, Col, Table, Spin, Select, Tooltip, Form } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import moment from 'moment-timezone';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent } from '../../../components';
import styles from './../styles.less';
import { PencilIcon, TrashIcon, CopyIcon } from '../../Icons';
import { hasHubspotProjectPermissions, WithHubspotProjectPermissions } from '../../Permissions';

class LeadScoringList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {},
      showProfilesArr: [{
        id: 1, label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.List.Filter.All' }), private: null,
      }, {
        id: 2, label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.List.Public' }), private: '0',
      }, {
        id: 3, label: this.props.intl.formatMessage({ id: 'Component.LeadScoring.List.Private' }), private: '1',
      }],
    };

    this.projectId = this.props.currentProject.id || this.props.match.params.projectId;
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Settings.LeadScoring.List.Label', description: 'Component.LeadScoring.List.Profile.Info',
      },
    });

    if (!this.props.hubspotOwners.assigned[this.projectId]) {
      this.props.dispatch({
        type: 'hubspotOwners/assigned',
        payload: {
          projectId: this.projectId,
        },
      });
    }


    this.showNotifications();
  }

  getData(psf) {
    const projectId = this.projectId;
    const filter = { name: this.state.filter.search };
    const params = psf.page ? psf : { sorting: psf.sorting };
    const includes = 'includes=related_to,scoringAttributes';

    if (this.state.filter.private) {
      filter.private = this.state.filter.private;
    }

    if (this.state.filter.hubspot_assignee) {
      filter.hubspot_assignee = this.state.filter.hubspot_assignee;
    }

    const payload = { projectId, includes, filter, ...params };

    if (Object.keys(this.state.filter).length > 0) {
      payload.filtered = true;
    }
    return this.props.dispatch({ type: 'leadScoring/loadList', payload });
  }

  showNotifications() {
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  showDeleteConfirm(record) {
    const _ = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage({ id: 'Component.LeadScoring.Modal.Description' }, { profileName: record.name }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        _.remove(record.id);
      },
    });
  }

  remove(id) {
    this.props.dispatch({ type: 'leadScoring/remove', payload: { id } }).then(() => {
      this.showNotifications();
      this.setState({ removedId: id });
    });
  }

  filterChangePrivate(value) {
    const { filter, showProfilesArr } = this.state;
    showProfilesArr.forEach((item) => {
      if (value === item.private) {
        filter.private = item.private;
      }
    });
    this.setState({ filter });
  }

  filterAssigneeOption = (inputValue, option) => {
    return option.props.title.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
  }

  render() {
    const { Column } = Table;
    const projectId = this.projectId;

    return (<div className={styles.containerLarge}>
      <Sticky
        className="sticky-bar"
        scrollElement=".ant-layout"
        stickyClassName="_sticky"
      >
        <div className="sticky-wrapper">
          <Row gutter={16}>
            <SearchComponent
              span={8}
              self={this}
              fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.LeadScoring.List.SearchByNamePlaceholder' })}
            />
            <Col span={5}>
              <Select
                style={{ width: '100%' }}
                defaultValue={this.state.showProfilesArr[0].label}
                onChange={this.filterChangePrivate.bind(this)}
              >
                {this.state.showProfilesArr.map(item => (<Select.Option key={item.id} value={item.private}>
                  {item.label}
                </Select.Option>))}
              </Select>
            </Col>

            {!hasHubspotProjectPermissions(this.props.currentProject, this.props.user) && <Col span={6} />}
            <WithHubspotProjectPermissions>
              <Col span={6}>
                <Select
                  style={{ width: '100%' }}
                  showSearch
                  showArrow
                  allowClear
                  placeholder={this.props.intl.formatMessage({ id: 'Component.LeadScoring.List.SearchByHubspotAssignee' })}
                  onChange={(value) => {
                    this.setState({ filter: { ...this.state.filter, hubspot_assignee: value } });
                  }}
                  filterOption={this.filterAssigneeOption}
                >
                  {(this.props.hubspotOwners.assigned[this.projectId] || []).map((c) => {
                    return (<Select.Option
                      key={c.id}
                      value={c.id}
                      title={`${c.first_name} ${c.last_name}`}
                    >
                      {c.first_name} {c.last_name}
                    </Select.Option>);
                  })}
                </Select>
              </Col>
            </WithHubspotProjectPermissions>
            <Col span={5} className="text-right">
              <Button
                size="large"
                type="primary"
                onClick={() => {
                  this.props.dispatch({
                    type: 'app/goToRoute', payload: { routeName: 'LEAD_SCORING_NEW', projectId },
                  });
                }}
              >
                <Icon type="plus" />
                <FormattedMessage id="Component.LeadScoring.List.Profile.Create" />
              </Button>
            </Col>
          </Row>
        </div>
      </Sticky>
      <Spin spinning={this.props.loading.models.leadScoring}>
        <AjaxTable
          updateKey={JSON.stringify([this.state.filter, this.state.removedId])}
          getData={this.getData.bind(this)}
          rowKey="id"
          className={styles.categoryList}
        >
          <Column
            title={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.ProfileName' })}
            key="name"
            dataIndex="name"
            sorter
            className={styles.tableColumnWrap}
            render={name => (
              <div data-label={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.ProfileName' })}>
                {name}
              </div>)}
          />
          <Column
            title={this.props.intl.formatMessage({ id: 'Grid.Column.Score' })}
            key="score"
            dataIndex="score"
            sorter
            className={styles.tableColumnWrap}
            render={score => (<div data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Score' })}>
              {score}
            </div>)}
          />
          <Column
            title={this.props.intl.formatMessage({ id: 'Grid.Column.Active' })}
            dataIndex="enabled"
            key="enabled"
            sorter
            className="text-center"
            render={(enabled) => {
              return (<div
                className="text-center"
                data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Active' })}
              >
                {enabled ? <Icon type="check" /> : <Icon type="close" />}
              </div>);
            }}
          />
          <Column
            title={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.User' })}
            key="user"
            dataIndex="related_to"
            className={styles.tableColumnWrap}
            render={data => (<div data-label={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.User' })}>
              {data ? <div>
                <div>{data.first_name}</div>
                <div>{data.last_name}</div>
              </div> : null}
            </div>)}
          />
          {hasHubspotProjectPermissions(this.props.currentProject, this.props.user) ? (<Column
            title={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.HubspotAssignee' })}
            className={styles.tableColumnWrap}
            render={data => (
              <div data-label={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.HubspotAssignee' })}>
                {data.hubspot_task_owner && data.hubspot_enabled ? <div>
                  <div>{data.hubspot_task_owner.first_name}</div>
                  <div>{data.hubspot_task_owner.last_name}</div>
                </div> : null}
              </div>)}
          />) : null}
          <Column
            title={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.LastChanged' })}
            key="updated_at"
            dataIndex="updated_at"
            sorter
            className={styles.tableColumnWrap}
            render={(lastChanged) => {
              const tz = moment.tz(lastChanged, this.props.user.display_timezone);
              return (<div data-label={this.props.intl.formatMessage({ id: 'Component.LeadScoring.Grid.LastChanged' })}>
                {moment(tz).format(this.props.user.display_datetime_format)}
              </div>);
            }}
          />
          <Column
            title={this.props.intl.formatMessage({
              id: 'Grid.Column.Actions',
            })}
            key="actions"
            className="text-center"
            width={150}
            fixed="right"
            render={item => (<div className="actions" data-label={item.id}>
              <Tooltip
                className="hint action-wrap"
                placement="top"
                title={this.props.intl.formatMessage({
                  id: 'Grid.Column.Edit',
                })}
              >
                <Link to={`./${item.id}/edit/`}>
                  <PencilIcon />
                </Link>
              </Tooltip>
              <Tooltip
                className="hint action-wrap"
                placement="top"
                title={this.props.intl.formatMessage({
                  id: 'Grid.Column.Copy',
                })}
              >
                <button
                  onClick={() => {
                    this.props.dispatch({
                      type: 'app/goToRoute',
                      payload: { routeName: 'LEAD_SCORING_NEW', projectId, copyProjectId: item.id },
                    });
                  }}
                >
                  <CopyIcon />
                </button>
              </Tooltip>
              <Tooltip
                className="hint action-wrap"
                placement="top"
                title={this.props.intl.formatMessage({
                  id: 'Grid.Column.Delete',
                })}
              >
                <button onClick={() => this.showDeleteConfirm(item)}>
                  <TrashIcon />
                </button>
              </Tooltip>
            </div>)}
          />
        </AjaxTable>
      </Spin>
    </div>);
  }
}

export default connect(({
  leadScoring, loading, app, hubspotOwners,
}) => ({
  leadScoring, loading, currentProject: app.currentProject, user: app.user, hubspotOwners,
}))(Form.create()(injectIntl(LeadScoringList)));



// WEBPACK FOOTER //
// ./src/components/LeadScoring/LeadScoringList/LeadScoringList.js